import { useTranslation } from "react-i18next";
import { DocumentPreview } from "@/components/print/DocumentPreview";
import { Button } from "@akuna/ui";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ViaTabs } from "./PrescriptionDraftPreviewCard";
import { usePrescriptionDraftPreview } from "./PrescriptionDraftContext";

export function PrescriptionPreviewDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const { t } = useTranslation("prescriptions");
  const { html, viaNames, activeVia, setActiveVia } = usePrescriptionDraftPreview();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] max-w-[860px] gap-3 overflow-hidden p-0 sm:rounded-2xl">
        <DialogHeader className="space-y-2 px-6 pt-5">
          <DialogTitle>{t("editor.preview.title")}</DialogTitle>
          <DialogDescription className="sr-only">{t("editor.preview.hint")}</DialogDescription>
          <ViaTabs names={viaNames} active={activeVia} onChange={setActiveVia} className="px-0" />
        </DialogHeader>
        <div className="max-h-[70vh] overflow-auto bg-print-workspace p-6">
          {html ? <DocumentPreview html={html} title={t("editor.preview.title")} scale={0.9} /> : null}
        </div>
        <DialogFooter className="items-center gap-3 px-6 pb-5 sm:justify-between">
          <p className="text-[13px] text-muted-foreground">{t("editor.preview.zoomHint")}</p>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            {t("editor.preview.close")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
